import moment from "moment";
import i18n from "../i18n.js";

let rolePriority = {
    "Admin": 1,
     "Manager": 2,
     "Editor": 3,
     "Viewer": 4
}

export const getCurrentUserDetail = () => {
    let userDetail = localStorage.getItem("v_userInfo");
    if (userDetail) {
        userDetail = JSON.parse(userDetail)
    }
    return userDetail
}

export const getSortedSpaces = (spaces) => {
    let sortedSpaces = spaces.sort((a, b) => a.name.localeCompare(b.name));
    return sortedSpaces;
}

export const sortSpacesByDate = (spaces) => {
    // spaces.sort((a,b) => {
    //     let aDate = 
    // })
    let sortedSpaces = spaces.sort((a, b) => moment.utc(a.createdOn).valueOf() - moment.utc(b.createdOn).valueOf())
    return sortedSpaces
}

export const getGroupAccess = (groupSpaces, spaceId) => {
    let reqGroupAccess = []
    if(groupSpaces?.length > 0) {
        groupSpaces.map(space => {
            let currentGroupAccess = space.groupAccess?.filter(access => access.resource === spaceId)
            if(currentGroupAccess?.length > 0) {
                reqGroupAccess = reqGroupAccess.concat(currentGroupAccess)
            }
        })
    }
    return reqGroupAccess
}

export const getUserSpaceEntitlements = (spaceId, userAccess, groupSpaces = []) => {
    let spaceEntitlements = []
    if (!spaceId && userAccess) {
        let adminAccess = userAccess.find(access => access.resourceType === "adminConfig");
        if (adminAccess) {
            spaceEntitlements = adminAccess.entitlements || []
        }
    }
    let spaceAccess = userAccess?.find(access => access.resource === spaceId);
    if (spaceAccess) {
        spaceEntitlements = spaceAccess.entitlements || []
        //   return spaceEntitlements
    }
    let groupAccess = getGroupAccess(groupSpaces, spaceId)
    if (spaceId && groupAccess) {
        let groupAccessObj = groupAccess.find(access => access.resource === spaceId)
        if (groupAccessObj?.role && spaceAccess) {
            let spacePriority = rolePriority[spaceAccess?.role]
            if (spacePriority) {
                let groupPriority = rolePriority[groupAccessObj?.role]
                if (groupPriority < spacePriority) {
                    spaceEntitlements = groupAccessObj?.entitlements || []
                }
            }
        }
        if (groupAccessObj && !spaceAccess) {
            spaceEntitlements = groupAccessObj?.entitlements || []
        }

    }

    return spaceEntitlements
}

// Read the user's persisted default view (List / Kanban / Graph) for a space.
// Stored as `selectedView` on the space's userAccess entry.
export const getUserSelectedView = (spaceId, userAccess = []) => {
    let spaceAccess = userAccess?.find(access => access.resource === spaceId && access.resourceType === "space");
    return spaceAccess?.selectedView || null;
}

export const getSpaceImage = (spaceId, spaceImages) => {
    let image = "";
    let spaceObj = spaceImages.find(space => space.spaceId === spaceId)
    if (spaceObj) {
        image = spaceObj.logoImage
    }
    return image
}

export const getGroupSpaces = (userGroupSpaces) => {
    let reqGroupSpaces = []
    if (userGroupSpaces?.length > 0) {
        userGroupSpaces.forEach(groupSpace => {
            if (groupSpace.space?.length > 0) {
                reqGroupSpaces = reqGroupSpaces.concat(groupSpace.spaceDetails)
            }
        })
    }
    return reqGroupSpaces
}

export const getCurrentSpaceData = (spaceId, spaceInfo = [], userGroupSpaces = []) => {
    let reqData = {};
    if (spaceInfo) {
        let spaceObj = spaceInfo.find(space => space.spaceId === spaceId)
        if (spaceObj) {
            reqData = spaceObj
        }
    }
    if (reqData && Object.keys(reqData).length === 0 && userGroupSpaces?.length > 0) {
        let reqGroupSpaces = getGroupSpaces(userGroupSpaces);
        reqData = reqGroupSpaces.find(groupSpace => groupSpace.spaceId === spaceId)
    }
    // Return the name/description in the current app language (fallback to the
    // canonical values) so callers (breadcrumbs, cards, ...) get localized text.
    const localized = reqData?.translations?.[i18n.language]
    if (localized) {
        reqData = {
            ...reqData,
            name: localized.name || reqData.name,
            description: localized.description || reqData.description,
        }
    }
    return reqData
}